export default __webpack_public_path__ + "static/media/img6.095fca50.png";